export enum adminRecruitmentPostTypes {
    FETCH_ADMIN_RECRUITMENT_POST_REQUEST = "FETCH_ADMIN_RECRUITMENT_POST_REQUEST",
    FETCH_ADMIN_RECRUITMENT_POST_SUCCESS = "FETCH_ADMIN_RECRUITMENT_POST_SUCCESS",
    FETCH_ADMIN_RECRUITMENT_POST_FAILURE = "FETCH_ADMIN_RECRUITMENT_POST_FAILURE",
  }